import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-warning-label',
  templateUrl: './warning-label.component.html',
  styleUrls: ['./warning-label.component.scss'],
})
export class WarningLabelComponent implements OnInit {
  @Input() data: string;
  @Input() color: string = '';
  @Input() textColor: string = '';
  @Input() icon: boolean = false;
  warning: string =
    'Please note: Any changes made here will be verified before it appears on your profile';
  constructor() {}

  ngOnInit(): void {}
}
